module.exports = __webpack_public_path__ + "img/Ängsvallen.12f87aaf.jpg";